import { useEffect, useState } from 'react'
import { useWindow } from './use.window'

export const useWindowSize = () => {
  const window = useWindow()

  const [windowSize, setWindowSize] = useState({
    height: 1024,
    width: 1280,
  })

  useEffect(() => {
    if (!window) {
      return
    }

    const getSize = () => ({
      height: window.innerHeight,
      width: window.innerWidth,
    })

    function handleResize() {
      setWindowSize(getSize())
    }

    setWindowSize(getSize())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [window]) // Empty array ensures that effect is only run on mount and unmount

  return windowSize
}
